import { connect } from 'react-redux';

import adminPaymentGateways from '_store/_actions/adminPaymentGateways';

import PaymentMethods from './PaymentMethods';

const mapStateToProps = state => {
  const { paymentMethods, isLoadingPaymentMethods } = state.adminPaymentGateways;

  return {
    paymentMethods,
    isLoading: isLoadingPaymentMethods,
  };
};

const mapDispatchToProps = {
  onFetchAdminPaymentMethods: adminPaymentGateways.fetchAdminPaymentMethods,
  onCreateAdminPaymentMethod: adminPaymentGateways.createAdminPaymentMethod,
  onUpdateAdminPaymentMethod: adminPaymentGateways.updateAdminPaymentMethod,
  onDeleteAdminPaymentMethod: adminPaymentGateways.deleteAdminPaymentMethod,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);
